import React from 'react';
import pageWrapper from './containers/MainPage';
import './NotFound.css';

export const NotFound = () => {
  return (
    <div className="notFound">
      <h2>Page Not Found</h2>
      <p>Sorry, couldn&apos;t find the page you were looking for!</p>
    </div>
  );
};

export default pageWrapper(NotFound, 'Page not Found (404)');



// WEBPACK FOOTER //
// ./src/components/NotFound.jsx